module.exports = __webpack_public_path__ + "static/media/5.10.34b830ac.png";